import type { FetchPoisInBoundaryArgs } from './fetcher';
import type { PoiBoundaryResponse } from './types';

/** Serializable body for same-origin POST to `/api/poi/bounds`; server runs {@link fetchPoisInBoundary}. */
export type FetchPoisInBoundaryJsonBody = Omit<FetchPoisInBoundaryArgs, 'host' | 'signal'>;

export async function fetchPoisInBoundaryJson(
  args: FetchPoisInBoundaryJsonBody & { signal?: AbortSignal }
): Promise<PoiBoundaryResponse> {
  const { signal, ...body } = args;
  const res = await fetch('/api/poi/bounds', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
    signal,
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`fetchPoisInBoundaryJson: ${res.status} ${text}`);
  }

  return res.json() as Promise<PoiBoundaryResponse>;
}
